const forEach = require('lodash/forEach');
const every = require('lodash/every');
const hasClass = require('../dom/has-class');
const removeClass = require('../dom/remove-class');
const constants = require('./constants');

function revealNestedTags() {
  const flowIdElements = window.document.querySelectorAll('[flow-id]');

  // Unhide any container elements if all of the children were localized
  forEach(flowIdElements, (flowIdElement) => {
    const children = flowIdElement.querySelectorAll('[flow-variant], [flow-order]');
    const allLocalized = every(children, childElement =>
      hasClass(childElement, constants.FLOW_LOCALIZED_CLASS));

    if (allLocalized) {
      removeClass(flowIdElement, constants.FLOW_HIDDEN_CLASS);
    }
  });
}

module.exports = revealNestedTags;



// WEBPACK FOOTER //
// ./static/js/v0/utilities/tags/reveal-nested-tags.js